import { ReactNode } from "react";
import { useDndContext, useDroppable } from "@dnd-kit/core";
import classNames from "classnames";
import { ActiveDrag, DropData } from "./journeyPlanner.types";

interface JourneyDropSlotProps {
  activeTypes: ActiveDrag["type"][];
  activeWhen?: (activeData?: ActiveDrag) => boolean;
  children?: ReactNode;
  className?: string;
  data: DropData;
  id: string;
}

/** A gap in a journey that lights up while something that can land there is over it. */
export function JourneyDropSlot({
  activeTypes,
  activeWhen,
  children,
  className,
  data,
  id,
}: JourneyDropSlotProps) {
  const { active } = useDndContext();
  const { isOver, setNodeRef } = useDroppable({ id, data });
  const activeData = active?.data?.current as ActiveDrag | undefined;
  const allowed =
    Boolean(activeData && activeTypes.includes(activeData.type)) &&
    (activeWhen ? activeWhen(activeData) : true);

  return (
    <div
      ref={setNodeRef}
      className={classNames(
        "droppable-element",
        className,
        allowed && "is-droppable",
        isOver && allowed && "is-over"
      )}
    >
      {children}
    </div>
  );
}

export default JourneyDropSlot;
